var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dropdown',{attrs:{"placement":_vm.placement,"size":"mini"}},[_vm._t("default"),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.text))])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }